import { CHANNEL_COLORS, CHANNEL_LABEL } from '../../pages/analytics/analytics.constants';
import { numberFormat } from '../../pages/weeklyreport/format';
import { type weeklyReportChannelTotals } from '../../services/api/weekly-report';

export const ChannelBreakdown = ({ byChannel }: { byChannel: weeklyReportChannelTotals }) => (
  <ul className="space-y-1">
    {Object.entries(byChannel).map(([channel, count]) => (
      <li
        key={channel}
        className="flex items-center justify-between border-b border-slate-100 py-2 last:border-0"
      >
        <span className="flex items-center gap-2">
          <span
            className="h-2.5 w-2.5 rounded-full"
            style={{ backgroundColor: CHANNEL_COLORS[channel] ?? '#94a3b8' }}
          />
          {CHANNEL_LABEL[channel] ?? channel}
        </span>
        <span className="font-medium">{numberFormat.format(count)}</span>
      </li>
    ))}
  </ul>
);
